import { versionReleasesTypes } from '../reduxExports';

const versionReleaseInitialState: VersionReleaseState = {
  versionReleases: null,
  versionReleasesCount: 0,
  versionReleaseTableProps: {
    view: 'list',
    sortBy: 'releaseDate',
    order: 'descending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: null
  },
  versionReleaseFiltersAppliedFromRedirection: false,
  versionReleaseTableListLoader: false,
  versionReleaseListRequestSearchHash: null,
  versionReleaseListRequestFilterHash: null,
  chargerOnVersionTrendInfo: null,
  chargerOnVersionTrendProductTypeHash: null,
  chargerOnVersionTrendFilterHash: null,
  chargerOnVersionTrendLoader:false,
  latestVersionInfo: null,
  latestVersionInfoLoader : false,
  deploymentProgressTrendInfo: null,
  deploymentProgressTrendFilterHash: null,
  deploymentProgressTrendLoader:false,
  deploymentProgressTrendProductTypeHash: null,
  deploymentLogs: null,
  deploymentLogsCount: 0,
  deploymentLogTableProps: {
    view: 'list',
    sortBy: 'requestedOn',
    order: 'descending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: null
  },
  deploymentLogsFiltersAppliedFromRedirection: false,
  deploymentLogTableListLoader: false,
  deploymentLogListRequestSearchHash: null,
  deploymentLogListRequestFilterHash: null,

};


const versionReleasesReducer = (
  state: VersionReleaseState = versionReleaseInitialState,
  action: VersionReleaseAction
): VersionReleaseState => {
  switch (action.type) {
    case versionReleasesTypes.FETCH_VERSION_RELEASE_DATA:
      return {
        ...state,
        versionReleases: action.versionReleases,
        versionReleasesCount: action.versionReleasesCount || 0
      };
    case versionReleasesTypes.SET_VERSION_RELEASE_TABLE_PROPS:
      return {
        ...state,
        versionReleaseTableProps: action.versionReleaseTableProps || state.versionReleaseTableProps
      };
    case versionReleasesTypes.SET_VERSION_RELEASE_FILTERS_APPLIED_FROM_REDIRECTION:
      return {
        ...state,
        versionReleaseFiltersAppliedFromRedirection: action.versionReleaseFiltersAppliedFromRedirection || false
      };
    case versionReleasesTypes.SET_VERSION_RELEASE_TABLE_LIST_LOADER:
      return {
        ...state,
        versionReleaseTableListLoader: action.versionReleaseTableListLoader || false
      };
    case versionReleasesTypes.SET_VERSION_RELEASE_LIST_REQUEST_HASH:
      return {
        ...state,
        versionReleaseListRequestSearchHash: action.versionReleaseListRequestSearchHash || null,
        versionReleaseListRequestFilterHash: action.versionReleaseListRequestFilterHash || null
      };
    case versionReleasesTypes.CLEAR_VERSION_RELEASE_DATA:
      return {
        ...versionReleaseInitialState
      };
    case versionReleasesTypes.FETCH_CHARGER_ON_VERSION_TREND_DATA:
      return {
        ...state,
        chargerOnVersionTrendInfo: action.chargerOnVersionTrendInfo
      }
    case versionReleasesTypes.SET_CHARGER_ON_VERSION_TREND_FILTER_HASH:
      return {
        ...state,
        chargerOnVersionTrendProductTypeHash: action.chargerOnVersionTrendProductTypeHash,
        chargerOnVersionTrendFilterHash: action.chargerOnVersionTrendFilterHash
      }
    case versionReleasesTypes.SET_CHARGER_ON_VERSION_TREND_LOADER:
      return {
        ...state,
        chargerOnVersionTrendLoader:action.chargerOnVersionTrendLoader || false
      }
    case versionReleasesTypes.FETCH_LATEST_VERSION_INFO_DATA:
      return {
        ...state,
        latestVersionInfo: action.latestVersionInfo
      }
    case versionReleasesTypes.SET_LATEST_VERSION_INFO_LOADER:
      return {
        ...state,
        latestVersionInfoLoader:action.latestVersionInfoLoader || false
      }
    case versionReleasesTypes.FETCH_DEPLOYMENT_PROGRESS_TREND_DATA:
      return {
        ...state,
        deploymentProgressTrendInfo: action.deploymentProgressTrendInfo
      }
    case versionReleasesTypes.SET_DEPLOYMENT_PROGRESS_TREND_FILTER_HASH:
      return {
        ...state,
        deploymentProgressTrendFilterHash: action.deploymentProgressTrendFilterHash,
        deploymentProgressTrendProductTypeHash: action.deploymentProgressTrendProductTypeHash
      }
    case versionReleasesTypes.SET_DEPLOYMENT_PROGRESS_TREND_LOADER:
      return {
        ...state,
        deploymentProgressTrendLoader:action.deploymentProgressTrendLoader || false
      }
    case versionReleasesTypes.FETCH_DEPLOYMENT_LOGS_DATA:
      return {
        ...state,
        deploymentLogs: action.deploymentLogs,
        deploymentLogsCount: action.deploymentLogsCount
      }
    case versionReleasesTypes.SET_DEPLOYMENT_LOGS_TABLE_PROPS:
      return {
        ...state,
        deploymentLogTableProps: action.deploymentLogTableProps || state.deploymentLogTableProps
      }
    case versionReleasesTypes.SET_DEPLOYMENT_LOGS_FILTERS_APPLIED_FROM_REDIRECTION:
      return {
        ...state,
        deploymentLogsFiltersAppliedFromRedirection: action.deploymentLogsFiltersAppliedFromRedirection || false
      };
    case versionReleasesTypes.SET_DEPLOYMENT_LOGS_TABLE_LIST_LOADER:
      return {
        ...state,
        deploymentLogTableListLoader: action.deploymentLogTableListLoader || false
      }
    case versionReleasesTypes.SET_DEPLOYMENT_LOGS_LIST_REQUEST_HASH:
      return {
        ...state,
        deploymentLogListRequestSearchHash: action.deploymentLogListRequestSearchHash || null,
        deploymentLogListRequestFilterHash: action.deploymentLogListRequestFilterHash || null
      };
    case versionReleasesTypes.CLEAR_DEPLOYMENT_LOGS_DATA:
      return {
        ...state,
        deploymentLogs: null,
        deploymentLogsCount: 0,
        deploymentLogTableProps: {
          view: 'list',
          sortBy: 'requestedOn',
          order: 'descending',
          pageSize: 15,
          pageNumber: 1,
          searchTerm: null
        },
        deploymentLogsFiltersAppliedFromRedirection: false,
        deploymentLogTableListLoader: false,
        deploymentLogListRequestSearchHash: null,
        deploymentLogListRequestFilterHash: null,
      };
    default:
      return state;
  }
};

export default versionReleasesReducer;